import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import moment from 'moment';

export default class Excess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      data: props.data || null,
    };
  }

  render() {
    /*
    console.log(this.state.data);
    agreed_deduction_amount: 10
​
company_id: 1
​
created_at: "2019-01-03 13:08:06"
​
current_amount_to_repay: 100
​
deduction_occurance: "weekly"
​
description: "test"
​
driver_excess_account_id: 1
​
driver_id: 1
​
id: 1
​
insurance_reference: "ref"
​
original_amount_to_repay: 100
​
paid_amount: null
​
updated_at: "2019-01-03 13:36:47"*/
        
    let details =   [];
    if(this.state.data.start_date != null && this.state.data.end_date != null){
      let startDate = (this.state.data.start_date != null) ? moment(this.state.data.start_date).format("YYYY-MM-DD") : "";        
      let endDate = (this.state.data.end_date != null) ? moment(this.state.data.end_date).format("YYYY-MM-DD") : "";  
      details.push(
        <span key={this.state.data.start_date}>Start Date:-{startDate}</span>
      );
      details.push(
        <span key={this.state.data.end_date}>End Date:-{endDate}</span>
      );
    }else if(this.state.data.selected_day != null){
      details.push(
        <span key={this.state.data.selected_day}>Selected Day:-{this.state.data.selected_day}</span>
      );
    }else if(this.state.data.selected_starttime != null && this.state.data.selected_endtime != null){
      details.push(
        <span key={this.state.data.selected_starttime}>
          Start Time:- {this.state.data.selected_starttime}
          </span>
      );
      details.push(
        <span key={this.state.data.selected_endtime}>
          End Time:- {this.state.data.selected_endtime}
          </span>
      );
    }
    return (
      <div className="row">
        <div className="col-md-2">
          {this.state.data.description}
        </div>
        <div className="col-md-2" title="reference">
          {this.state.data.insurance_reference}
        </div>
        <div className="col-md-2">
          &pound;{this.state.data.amount_paid} / &pound;{this.state.data.original_amount_to_repay}
        </div>
        <div className="col-md-2">
          &pound;{this.state.data.agreed_deduction_amount} {this.state.data.deduction_occurance}
        </div>
        <div className="col-md-4 details">
          {details}
        </div>
      </div>
    );
  }

}
